import { render } from "./GithubIcon.vue?vue&type=template&id=50f079a0"
import script from "./GithubIcon.vue?vue&type=script&lang=js"
export * from "./GithubIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__